import { inject, injectable } from 'tsyringe';
import { type IContactRepository } from 'application/repositorySchemas/IContactRepository';
import { type IContactClient } from 'interfaceAdapter/gatewaySchemas/IContactClient';
import { ContactCategoryTypes } from 'domain/valueObjects/Contact/Contact';

@injectable()
export class ContactRepository implements IContactRepository {
    constructor(
        @inject('IContactClient')
        public readonly contactClient: IContactClient,
    ) {}

    public post = async (
        email: string,
        name: string,
        category: ContactCategoryTypes,
        content: string,
    ): Promise<void> => {
        const { message } = await this.contactClient.post({
            email,
            name,
            category,
            content,
        });

        if (message) {
            throw new Error(message);
        }
    };
}
